<script lang="ts" setup>
import { PropType } from 'vue';
import { Invoice } from '@/models/invoice';
import InvoiceItem from './InvoiceItem.vue';

const { invoices, showHeader } = defineProps({
  invoices: {
    type: Array as PropType<Invoice[]>,
    required: true,
  },
  showHeader: {
    type: Boolean,
    default: true,
  },
});
</script>
<template>
  <section class="section">
    <h3 v-if="showHeader">Invoices</h3>
    <ul class="compound" v-if="invoices.length">
      <InvoiceItem
        v-for="invoice in invoices"
        :key="invoice.id"
        :invoice="invoice"
      ></InvoiceItem>
    </ul>
    <p v-else-if="showHeader">There are no invoices for this period.</p>
  </section>
</template>
